import styled from 'styled-components';
import images from '../../config/images';
import { isWebinar } from '../../lib/lib'

export const Background = isWebinar() ? 
  styled.div`
  background: #0c65b4;
  position: absolute;
  height: 100vh;
  box-shadow: 0px 8px 8px rgba(0, 0, 0, 0.24), 0px 16px 32px rgba(0, 0, 0, 0.32);
` : styled.div`
  background: #d8d5d0;
  position: absolute;
  height: 100vh;
  box-shadow: 0px 8px 8px rgba(0, 0, 0, 0.24), 0px 16px 32px rgba(0, 0, 0, 0.32);
`

export const Top = styled.div`
  height: 0vh;
  position: absolute;
  width: 100%;
  left: 0px;
  top: 0px;

  background: #eaeaea;
  transform: rotate(-180deg);
`;

export const Bottom = styled.div`
  height: 0vh;
  position: absolute;
  width: 100%;
  bottom: 0px;
  background: linear-gradient(180deg, rgba(0, 0, 0, 0.0001) 0%, rgba(0, 0, 0, 0.193869) 98.41%);
`;

export const Mask = isWebinar() ? styled.div`
  height: 100vh;
  background: linear-gradient(0deg, #2A66AE, #2A66AE), #168061;
  box-shadow: 0px 8px 8px rgba(0, 0, 0, 0.24), 0px 16px 32px rgba(0, 0, 0, 0.32);
` : styled.div`
  height: 100vh;
  background: #eaeaea;
  box-shadow: 0px 8px 8px rgba(0, 0, 0, 0.24), 0px 16px 32px rgba(0, 0, 0, 0.32);
` 


export const SessionBackground = styled.div`
  background-image: url(${images.sessionBackground});
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center center;
`;




// WEBPACK FOOTER //
// ./src/routes/SeminarMode/styles.js